import React, { useState, useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { translate } from 'base/shared/Localization';
import { Input } from 'app/badi-components/input';
import { BOOKING_STEPS } from 'app/Sections/booking/constants';
import { getColor } from 'base/shared/get-color';

const GuestInformationCard = styled.div`
  background: #f5f7fa;
  padding: 32px;
  border-radius: 16px;

  input {
    background-color: white;
  }
`;

const GuestInformation = ({ guestInformation, onValidation }) => {
  const [guest, setGuest] = useState({
    guestFirstName: guestInformation.guestFirstName,
    guestLastName: guestInformation.guestLastName,
    guestEmail: guestInformation.guestEmail,
    guestFormattedPhone: guestInformation.guestFormattedPhone,
  });

  const [errors, setErrors] = useState({
    guestFirstName: false,
    guestLastName: false,
    guestEmail: false,
    guestFormattedPhone: false,
  });

  useEffect(() => {
    const hasErrors = Object.values(errors).some(Boolean);

    if (hasErrors) {
      onValidation({
        id: BOOKING_STEPS.PAYMENT_CHECKOUT,
        valid: false,
        payload: {},
      });
    } else {
      onValidation({
        id: BOOKING_STEPS.PAYMENT_CHECKOUT,
        valid: true,
        payload: guest,
      });
    }
  }, [errors, guest]);

  const handleFieldChange = (event) => {
    const { name, value } = event.currentTarget;

    const updatedGuest = {
      ...guest,
      [name]: value,
    };

    setGuest(updatedGuest);

    let validation;

    if (name === 'guestFormattedPhone') {
      validation = !validatePhone(value);
    } else if (name === 'guestEmail') {
      validation = !validateEmail(value);
    } else {
      validation = value.trim().length === 0;
    }

    const updatedErrors = {
      ...errors,
      [name]: validation,
    };

    setErrors(updatedErrors);
  };

  const validateEmail = (email) => {
    if (!email) return false;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhone = (phone) => {
    if (!phone) return false;

    // Remove spaces, dashes, parentheses
    const cleaned = phone.replace(/[\s()-]/g, '');

    // E.164 format: + followed by 7–15 digits
    const e164Regex = /^\+\d{7,15}$/;

    return e164Regex.test(cleaned);
  };

  return (
    <GuestInformationCard>
      <Input
        value={guest.guestFirstName}
        iconName="verified-check"
        iconColor={getColor('success')}
        hasError={errors.guestFirstName}
        required
        onChange={handleFieldChange}
        name="guestFirstName"
        label={translate('recovery.badi_plus_payment_checkout_guest_information.labels.first_name')}
      />
      <Input
        value={guest.guestLastName}
        iconName="verified-check"
        iconColor={getColor('success')}
        hasError={errors.guestLastName}
        required
        onChange={handleFieldChange}
        name="guestLastName"
        label={translate('recovery.badi_plus_payment_checkout_guest_information.labels.last_name')}
      />
      <Input
        value={guest.guestEmail}
        iconName="verified-check"
        iconColor={getColor('success')}
        hasError={errors.guestEmail}
        type="email"
        required
        onChange={handleFieldChange}
        name="guestEmail"
        label={translate('recovery.badi_plus_payment_checkout_guest_information.labels.email')}
      />
      <Input
        value={guest.guestFormattedPhone}
        iconName="verified-check"
        iconColor={getColor('success')}
        hasError={errors.guestFormattedPhone}
        placeholder="i.e.: +34 999 999 999"
        type="tel"
        required
        onChange={handleFieldChange}
        name="guestFormattedPhone"
        label={translate('recovery.badi_plus_payment_checkout_guest_information.labels.phone')}
      />
    </GuestInformationCard>
  );
};

export default GuestInformation;
